import { Grid, GridItem } from '@imported/constellation';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { PageHeading, TakePhotoContentForm } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import { proofOfIdentitydefaultValues, } from '../../components/ProofOfIndentityForm/types.js';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { ROUTE_PATHS } from '../../utils/routePaths.js';
const TakePhotoContent = () => {
    const methods = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        defaultValues: proofOfIdentitydefaultValues,
    });
    const { handleSubmit } = methods;
    const { idvState } = useIdvProvider();
    const { getLabelFromContext } = useLabelContext();
    const [description, setDescription] = useState([]);
    const option = getLabelFromContext('components.proofOfIdentity.options');
    const [title, setTitle] = useState(getLabelFromContext('containers.takePhotoContent.pageTitlePassport'));
    const [imageUrl, setImageUrl] = useState([]);
    const navigate = useNavigate();
    const handleProofOfIdentitySubmission = useCallback(() => {
        handleSubmit(() => {
            if (idvState.identityState.documentOption !== '') {
                navigate(`../${ROUTE_PATHS.SCAN_DOCUMENT}/${idvState.identityState.documentOption}`);
                return;
            }
            navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
        })();
    }, [handleSubmit, idvState, navigate]);
    const handlePreviousPage = useCallback(() => {
        navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
    }, [navigate]);
    useEffect(() => {
        if (idvState.identityState.documentOption === '') {
            navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
        }
        if (idvState.identityState.documentOption === option[0].value) {
            setDescription(getLabelFromContext('components.takePhotoContent.passport.desc'));
            setImageUrl([
                `${idvState.assetsPath}/images/passport_2.jpg`,
                `${idvState.assetsPath}/images/passport_1.jpg`,
            ]);
        }
        if (idvState.identityState.documentOption === option[1].value) {
            setDescription(getLabelFromContext('components.takePhotoContent.dl.desc'));
            setImageUrl([
                `${idvState.assetsPath}/images/dl_2.jpg`,
                `${idvState.assetsPath}/images/dl_1.jpg`,
            ]);
            setTitle(getLabelFromContext('containers.takePhotoContent.pageTitleDL'));
        }
    }, [
        getLabelFromContext,
        idvState.assetsPath,
        idvState.identityState,
        idvState.identityState.documentOption,
        navigate,
        option,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { journeyTitle: idvState.labels.applicationHeading, pageTitle: title }),
        React.createElement(Grid, null,
            React.createElement(GridItem, { md: 8, sm: 12 },
                React.createElement(TakePhotoContentForm, { description: description, imageUrl: imageUrl, handlePreviousPage: handlePreviousPage, handleProofOfIdentitySubmission: handleProofOfIdentitySubmission })),
            React.createElement(GridItem, { md: 4, sm: 12 },
                React.createElement(NeedHelp, null)))));
};
export default TakePhotoContent;
//# sourceMappingURL=index.js.map